<avd-styling-card-shell [label]="label">
    <div token-card-preview class="overlay_swatch" #preview>
        <div class="overlay_swatch__content">
            <p class="overlay_swatch__text">
                Drag the handle on the overlay to move it across the preview
                window.
            </p>
        </div>

        <div
            class="overlay_swatch__layer"
            [style.width.%]="overlayPosition"
            [style.background-color]="
                overlayColor ? 'var(' + overlayColor + ')' : 'transparent'
            "
        >
            <button
                class="overlay_swatch__handle"
                type="button"
                aria-label="Drag overlay handle"
                (pointerdown)="startOverlayDrag($event, preview)"
            >
                <uilab-mat-icon
                    svgIcon="organize--drag_filled"
                ></uilab-mat-icon>
            </button>
        </div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
